export default __webpack_public_path__ + "static/media/light.13eb8a5b.svg";